<template>
  <div>
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招聘列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item>
        <el-button type="primary" @click="childAdd">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-input v-model="queryForm.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" icon="el-icon-search" circle @click="serch()"></el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="招聘列表" name="first">
        <el-table :data="studentData" stripe style="width: 100%">
          // id
          <el-table-column type="index" width="50"></el-table-column>// 招聘类型
          <el-table-column prop="title" label="招聘类型" width="180" align="center"></el-table-column>

          <el-table-column prop="title_en" label="英文类型" width="180" align="center"></el-table-column>

          <!-- <el-table-column
            prop="type"
            label="分类"
            width="300"
            align="center">
          </el-table-column>-->
          // 招聘内容
          <el-table-column prop="menu" label="招聘内容" width="200" align="center">
            <template slot-scope="scope">
              <!-- <el-tooltip placement="top"> -->
              <!-- <div slot="menu">{{scope.row.menu}}</div> -->
              <!-- <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{scope.row.menu}}</div> -->
              <!-- <span v-for="item in scope.row.menu" :key="item">{{item}}</span> -->
              <!-- <span>{{scope.row.menu}}</span> -->
              <el-tag style="margin-right:10px;" v-for="item in scope.row.menu" :key="item">{{item}}</el-tag>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>

          <el-table-column prop="menu_en" label="英文内容" width="300" align="center">
            <template slot-scope="scope">
              <!-- <el-tooltip placement="top"> -->
              <!-- <div slot="menu">{{scope.row.menu}}</div> -->
              <!-- <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{scope.row.menu}}</div> -->
              <!-- <span v-for="item in scope.row.menu" :key="item">{{item}}</span> -->
              <!-- <span>{{scope.row.menu}}</span> -->
              <el-tag
                style="margin-right:10px;"
                v-for="item in scope.row.menu_en"
                :key="item"
              >{{item}}</el-tag>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="address"
            label="地址"
            width="200"
            align="center">
          </el-table-column>-->

          <!-- <el-table-column
            prop="email"
            label="邮箱"
            width="180"
            align="center">
          </el-table-column>-->
          //封面图
          <el-table-column label="封面图">
            <template slot-scope="scope">
              <img height="100px" class="img" :src="scope.row.image" alt />
            </template>
          </el-table-column>// 状态
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                @click="isStatus(scope.row)"
                size="mini"
                :type="scope.row.status==1 ? 'success':'info'"
                round
                ref="button"
              >{{scope.row.statusCH}}</el-button>
            </template>
          </el-table-column>//权重
          <el-table-column label="权重" prop="order" width="80" align="center"></el-table-column>//操作
          <el-table-column label="操作" width="200"  align="center">
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="del(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- <el-tab-pane label="招生列表" name="second">
        <el-table
          :data="studentData"
          stripe
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="name"
            label="带班老师"
            width="180"
            align="center">
          </el-table-column>
           <el-table-column
            prop="type"
            label="分类"
            width="300"
            align="center">
          </el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            width="300"
            align="center">
              <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">{{scope.row.content}}</div>
              <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{scope.row.content}}</div>
            </el-tooltip>
          </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            width="200"
            align="center">
          </el-table-column>
           <el-table-column
            prop="email"
            label="邮箱"
            width="180"
            align="center">
          </el-table-column>
           <el-table-column
            label="状态"
            width="80"
            align="center">
          <template slot-scope="scope">
             <el-button @click="isStatus(scope.row)" size="mini" :type="scope.row.status==0 ? 'success':'info'"  round  ref="button">{{scope.row.statusCH}}</el-button>
          </template>
          </el-table-column>
              <el-table-column
                  label="权重"
                  prop="order"
                  width="80"
                  align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>-->
    </el-tabs>
    <!--弹出框-->
    <!-- <el-dialog
      title="提示"
      :visible.sync="childVisible"
      width="800px"
      :before-close="handleClose">
      <el-form ref="form" label-width="80px" :model="childForm">
        <el-form-item label="选择列表">
          <el-select v-model="type" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value1"
              :label="item.label"
              :value="item.value1">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类别"
            :rules="[
          { required: true, message: '姓名不能为空'},
        ]">
          <el-input v-model="childForm.name"></el-input>
        </el-form-item>       
        <el-form-item label="邮箱"
         :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ]">
          <el-input v-model="childForm.email"></el-input>
        </el-form-item>
         <el-form-item label="地址"
            :rules="[
          { required: true, message: '地址不能为空'},
        ]">
          <el-input v-model="childForm.address"></el-input>
        </el-form-item>   
         <el-form-item label="权重" prop="order"
           :rules="[
            { type: 'number', message: '权重必须为数字值'}
          ]">
             <el-input v-model="childForm.order" size="mini"></el-input>
         </el-form-item>
          <el-form-item label="是否发布" :rules="[
          { required: true, message: '不能为空'},
        ]">
             <el-select v-model="status" placeholder="请选择发布或草稿">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
               </el-option>
             </el-select>
         </el-form-item >
        <el-form-item label="详细内容">
          <router-view/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="subChild">确 定</el-button>
      </span>
    </el-dialog>-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5,10,15]"
      :page-size="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- <Backfooter></Backfooter> -->
    <div class="footer">
      <div class="footer-bottom">
        <span>
          © 2009-{{this.year}} 大树联合集团 Powered By
          <a href="http://www.xiaoxxx.com/">小仙科技</a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Backfooter from "../../components/dashu/backfooter";
export default {
  components: { Backfooter },
  data() {
    return {
      pageVal: 1,
      pageSize: 5,
      currentPage: 1,
      type: 1,
      id: "",
      dataF: "",
      total: 0,
      queryForm: {
        keyword: "",
        year: ""
      },
      activeName: "first",
      studentData: [
        {
          order: 0,
          content: "",
          address: "",
          name: "",
          email: "",
          type: "",
          status: ""
        }
      ],
      flag: 1,
      // childVisible: false,
      // childForm: {
      //   address:'',
      //   name:'',
      //   type:'',
      //   order:0,
      //   email:'',
      //   content:'',
      // },
      headers: {
        Authorization: ""
      }
      //    options1: [{
      //     value1: 1,
      //     label: '招生列表'
      //   }, {
      //     value1:2,
      //     label: '招聘列表'
      //   }, ],
      //     options: [{
      //     value: 0,
      //     label: '发布'
      //   }, {
      //     value: 1,
      //     label: '草稿'
      //   }],
      // status: '',
    };
  },
  methods: {
    serch() {
      this.$http
        .post("/admin/dashu/recruit/recruitList", {
          page: this.pageVal,
          pageSize: this.pageSize,
          noPaginate: 1,
          keyword: this.queryForm.keyword,
          type: this.type
        })
        .then(res => {
          //  console.log(res.data.data.list)
          var code = res.data.code;
          if (code === 0) {
            // this.tableData=res.data.data.list
            this.studentData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    isStatus(row) {
      this.$confirm("是否改变状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //  console.log(row.id)
          this.$http
            .post("/admin/dashu/recruit/changeStatus", {
              id: row.id
            })
            .then(res => {
              var code = res.data.code;
              if (code === 0) {
                // this.$refs.button.style="background-color:none"
                this.$message({
                  type: "success",
                  message: "改变成功!"
                });
                this.getList();
              }
            })
            .catch(function(error) {
              // console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    getList() {
      this.$http
        .post("/admin/dashu/recruit/recruitList", {
          page: this.pageVal,
          pageSize: this.pageSize,
          noPaginate: 1,
          keyword: this.queryForm.keyword,
          type: this.type
        })
        .then(res => {
          //  console.log(res.data.data)
          var code = res.data.code;
          if (code === 0) {
            this.studentData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    childAdd() {
      // this.childVisible = true
      // this.flag=1;
      this.$router.push({
        name: "backCaseAdd",
        query: { type: "backRecruit" }
      });
    },
    handleClick(tab, event) {
      this.type = Number(tab.index) + 1;
      this.getList();
    },
    upImgSuccess(res) {},
    compile(row) {
      this.$router.push({
        name: "backCaseEdit",
        query: { type: "backRecruit", id: row.id }
      });
    },
    del(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // console.log(row)
          this.id = row.row.id;
          this.$http
            .post("/admin/dashu/recruit/delete", {
              id: this.id
            })
            .then(res => {
              var code = res.data.code;
              if (code === 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getList();
              }
            })
            .catch(function(error) {
              //  console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 关闭弹窗
    handleClose() {
      let obj = this.childForm;
      let flag = false;
      // 判断表单是否有填写
      for (var index in obj) {
        if (!obj[index]) {
          // console.log('无')
        } else {
          // console.log('有')
          flag = true;
          break;
        }
      }
      if (flag === true) {
        this.$confirm("关闭后编辑内容将撤销！")
          .then(_ => {
            this.childVisible = false;
            this.childForm.title = "";
            this.childForm.address = "";
            this.childForm.email = "";
            this.$store.commit("upUeData", "");
          })
          .catch(_ => {});
      } else {
        this.childVisible = false;
      }
    },
    // 提交
    subChild(row) {
      let ueData = this.$store.state.ueData;
      if (this.flag != 1) {
        this.$http
          .post("/admin/recruit/update", {
            status: this.status,
            order: this.childForm.order,
            content: this.dataF,
            id: this.id,
            email: this.childForm.email,
            name: this.childForm.name,
            address: this.childForm.address,
            type: this.type
          })
          .then(res => {
            //  console.log(res.data.data)
            var code = res.data.code;
            if (code === 0) {
              this.childVisible = false;
              this.$store.commit("upUeData", "");
              this.$message({
                message: "编辑成功",
                type: "success"
              });
              this.getList();
            } else if (code === -1) {
              this.$message({
                showClose: true,
                message: "请检查是否填写完整",
                type: "error"
              });
            }
          })
          .catch(function(error) {
            //  console.log(error);
          });
      } else {
        //新增
        this.$http
          .post("/admin/recruit/create", {
            status: this.status,
            order: this.childForm.order,
            content: this.dataF,
            email: this.childForm.email,
            name: this.childForm.name,
            address: this.childForm.address,
            type: this.type
          })
          .then(res => {
            //  console.log(res.data.data)
            var code = res.data.code;
            if (code === 0) {
              this.childVisible = false;
              this.$store.commit("upUeData", "");
              this.childForm.title = "";
              this.childForm.address = "";
              this.childForm.name = "";
              this.childForm.email = "";
              this.$store.commit("upUeData", "");
              this.$message({
                message: "新增成功",
                center: true,
                type: "success"
              });

              this.getList();
            } else if (code === -1) {
              this.$message({
                showClose: true,
                message: "请检查是否填写完整",
                type: "error"
              });
            }
          })
          .catch(function(error) {
            // console.log(error);
          });
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      //  console.log(`当前页: ${val}`);
      this.pageVal = val;
      this.getList();
    }
  },
  created() {
    var now = new Date();
    var year = now.getFullYear(); //获取当前年份
    this.year = year;
    this.headers.Authorization = window.localStorage.getItem("user_token");
    this.getList();
  },
  computed: {
    getUeData() {
      return this.$store.state.ueData;
    }
  },
  watch: {
    getUeData: function(old, newd) {
      // console.log(old)
      this.dataF = old;
    }
  }
};
</script> 

<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 50px;
  padding-bottom: 30px;
}
.footer {
  border-top: 1px solid grey;
  background: #e9eef3;
  margin: 10px -20px 0;
  width: 102%;
  min-width: 1200px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  /* position: fixed !important; */
  bottom: 0;
}
.footer-bottom {
  width: 50%;
  margin: 0 15%;
  padding: 1% 10%;
  color: grey;
}
.footer-bottom {
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
  font-size: 16px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
a {
  color: grey;
}
a:hover {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/pages/backPages/recruit.vue